import script from "./CustomerBehaviorPeriodPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerBehaviorPeriodPicker.vue?vue&type=script&setup=true&lang=js"

import "./CustomerBehaviorPeriodPicker.vue?vue&type=style&index=0&id=99ced0a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99ced0a6"]])

export default __exports__